import { get, post, put, del } from '../utils/httpInterceptor';
import { buildCrudQueryParams } from './filterQueryBuilder';

class CareLinkService {

    static async getByPublicToken(publicToken) {
        return await get(`/carelink/public/${encodeURIComponent(publicToken)}`);
    }

    static async getAll(page, size, filters = {}, sortConfig = {}) {
        const queryParams = buildCrudQueryParams({
            page,
            size,
            filters,
            sortConfig,
            sortMode: 'split',
        });
        return await get(`/carelink?${queryParams.toString()}`);
    }

    static async getById(id) {
        return await get(`/carelink/${id}`);
    }

    static async create(payload) {
        return await post('/carelink', payload);
    }

    static async update(id, payload) {
        return await put(`/carelink/${id}`, payload);
    }

    static async delete(id) {
        return await del(`/carelink/${id}`);
    }

    static async updateEnabled(id, payload) {
        return await put(`/carelink/enabled/${id}`, payload);
    }
}

export default CareLinkService;
